module.exports = __webpack_public_path__ + "static/media/game_title.42f8fbb1.png";